import { PROJECT_PERMISSION, USER_ACCESS_ROLE } from '~/modules/common/enums';

export const hasProposeActionAllowed = ({ permissionsMap, userAccessRoles }) =>
  Boolean(
    permissionsMap[
      'urn:replicon:resource-assignment-action:edit-resource-assignments'
    ] && userAccessRoles.includes(USER_ACCESS_ROLE.RESOURCE_MANAGER)
  );

export const hasAcceptActionAllowed = ({ permittedActionUris }) =>
  permittedActionUris.includes(PROJECT_PERMISSION.EDIT_PROJECT) &&
  permittedActionUris.includes(PROJECT_PERMISSION.EDIT_TEAM);
